import React from 'react';
import { AboutUsSubtitle, AboutUsBody, AboutUsHeader } from './styled';
import VerticalSpacer from '../VerticalSpacer';

const AboutUsBeforeItalist = () => (
  <div>
    <AboutUsHeader>Before italist</AboutUsHeader>
    <VerticalSpacer height="20px" />
    <AboutUsBody>
      Once upon a time, style professionals and fashion lovers had a secret.
      <br />
      <br />
      Insiders knew that by visiting boutiques in Italy, they could find in-season fashion and luxury accessories from
      their favorite designers and emerging brands at the best price.
      <br />
      <br />
      Back then, industry insiders had two ways to stock up.
      <br />
      <br />
      They could fly to Italy, shop at the boutiques in person, and stuff their suitcases with as much as they could
      carry home.
      <br />
      <br />
      Or they could communicate with the retailers directly to arrange the import of these luxury goods from Italy to
      their respective country. This was often a lengthy process, which required personal relationships and knowledge of
      the Italian language, and customers had to navigate the complicated customs process on their own.
      <br />
      <br />
      We saw a better way.
    </AboutUsBody>
    <VerticalSpacer height="10px" />
    <AboutUsHeader>Luxury Meets Tech</AboutUsHeader>
    <VerticalSpacer height="20px" />
    <AboutUsBody>
      In 2014, italist was born in Silicon Valley. That fall, italist received funding from 500 Startups and other
      institutional investors. Soon after, italist opened an office in Los Angeles where the company is now based.
      <br />
      <br />
      The initial vision was simple: partner directly with boutiques through a digital platform dedicated only to luxury
      products. To that end, we designed an innovative import model that combined tech and luxury.
      <br />
      <br />
      The buyers at our partner boutiques curate the products on italist, and all the items featured online are
      currently available in retail locations across Italy. This model allows customers to purchase goods at Italian
      retail price as if they'd flown to Italy and visited the stores in person.
    </AboutUsBody>
  </div>
);

export default AboutUsBeforeItalist;
